export const DATA_TEST_IDS = {
  profileProfileMenu: 'layout__profile_profile-menu',
};
export default DATA_TEST_IDS;
